import { AddIcon } from '@assets/icons';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { Stack, type SxProps, type TypeBackground } from '@mui/material';
import { type ReactNode } from 'react';

type CardButtonProps = {
  label: string;
  info?: ReactNode;
  background?: keyof TypeBackground;
  sx?: SxProps;
  onClick: () => void;
};

export const CardButton = ({
  sx,
  info,
  label,
  onClick,
  background = 'default',
  ...props
}: CardButtonProps) => {
  return (
    <Stack
      alignItems="center"
      role="button"
      gap={2}
      justifyContent="center"
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        backgroundColor: `background.${background}`,
        color: `foreground.${background}.light`,
        cursor: 'pointer',
        '&:hover': {
          color: `foreground.${background}.default`,
          borderColor: `foreground.${background}.default`,
        },
        ...sx,
      }}
      onClick={onClick}
      {...props}
    >
      {info}
      <Group alignItems="center" gap={2}>
        <AddIcon size={14} />
        <Typography variant="body2">{label}</Typography>
      </Group>
    </Stack>
  );
};
